"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _LabelWrapper = _interopRequireDefault(require("../../LabelWrapper")),
    _switch = require("../styles/switch");

function generateContainerClassName(a, b) {
  return (0, _classnames["default"])({
    "switch--checked": a,
    "switch--disabled": b
  });
}

function onChangeHandler(a, b) {
  return a ? function (c) {
    c.preventDefault(), a(!b);
  } : a;
}

function Switch(a) {
  var b = a.id,
      c = a.checked,
      d = a.disabled,
      e = a.label,
      f = a.className,
      g = a.onChange,
      h = a.labelProps,
      i = onChangeHandler(g, c),
      j = generateContainerClassName(c, d);
  return _react["default"].createElement(_LabelWrapper["default"], (0, _extends2["default"])({}, h, {
    id: b,
    label: e
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("switch--toggle", _switch.TOGGLE, f)
  }, _react["default"].createElement("label", {
    className: (0, _classnames["default"])("switch", j, _switch.SWITCH, (0, _defineProperty2["default"])({}, _switch.DISABLED, d)),
    htmlFor: b
  }, _react["default"].createElement("input", {
    id: b,
    className: (0, _classnames["default"])("switch-input", _switch.SWITCH_INPUT),
    type: "checkbox",
    value: c,
    checked: c,
    onClick: i,
    disabled: d,
    readOnly: !0
  }), _react["default"].createElement("div", null, _react["default"].createElement("span", {
    className: (0, _classnames["default"])("slider-before", {
      "slider-before--checked": c
    }, (0, _switch.SLIDER_BEFORE)({
      checked: c
    }))
  }), _react["default"].createElement("span", {
    className: (0, _classnames["default"])("slider", {
      "slider--checked": c
    }, (0, _switch.SLIDER)({
      checked: c
    }))
  })))));
}

var _default = (0, _react.memo)(Switch);

exports["default"] = _default;